/**
 * Curated fallback egg + TM move pool for the v0.1 Kanto roster. Used by
 * data/eggMoves.ts when @pkmn/dex returns an empty list for a species
 * (defensive path (g) of the Pokédex design doc). Gen-3 only — keep the
 * moves period-appropriate.
 *
 * Each entry is a small set of "things this species could plausibly know
 * outside its level-up set." Egg moves (parent-bred) + iconic Gen-3 TMs.
 * The actual selection is one of these (weighted equally) when the rare-
 * pull roll fires.
 *
 * Order within each species' list is canonical — the pool index is
 * derived from a deterministic rng draw, so re-ordering changes byte
 * stability.
 */

export const FALLBACK_EGG_MOVES: Record<string, readonly string[]> = {
  bulbasaur: ['skullbash', 'charm', 'sleeppowder', 'megadrain'],
  charmander: ['bellydrum', 'dragondance', 'metalclaw', 'irontail'],
  squirtle: ['mirrorcoat', 'haze', 'bite', 'icebeam'],
  caterpie: ['bugbite'],
  weedle: ['twineedle', 'poisonjab'],
  metapod: ['harden'],
  kakuna: ['harden'],
  pidgey: ['aircutter', 'pursuit', 'steelwing'],
  spearow: ['quickattack', 'faintattack', 'steelwing'],
  rattata: ['reversal', 'bite', 'counter'],
  pikachu: ['volttackle', 'reversal', 'surf', 'submission'],
  geodude: ['curse', 'magnitude', 'earthquake', 'rockslide'],
  onix: ['block', 'magnitude', 'rockslide', 'irontail'],
};
